module.exports = __webpack_public_path__ + "media/addition.36622afc.svg";